const NetworkDetectionsServerIp = (props) => {
  const serverIp = props?.row?.original?.log?.serverIp || "-";

  return <span>{serverIp}</span>;
};

export default NetworkDetectionsServerIp;
